module.exports = __webpack_public_path__ + "img/game_show.ce4d9400.png";